import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "flatpickr/dist/themes/material_blue.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MetaTags } from "react-meta-tags";
import {
  getAppData,
  setAppDataNull,
  getApp,
  patchApp,
  setApp,
  patchAppStatus,
} from "../../../store/apps/actions";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import ApplicationForm from "../../../components/forms/ApplicationForm";
import { getTrackerPlatforms } from "../../../store/meta/actions";
import SweetAlert from "react-bootstrap-sweetalert";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

const EditApplication = props => {
  const url_data = props.match.params;
  const [infoAlert, setInfoAlert] = React.useState(false);
  const [infoData, setInfoData] = React.useState(null);

  useEffect(() => {
    props.getTrackerPlatforms();
    props.getApp(url_data.appId);

    return () => {
      props.setApp(null);
      props.setAppDataNull()
    };
  }, []);

  const onSubmitForm = data => {
    props.app?.is_active &&
      props.patchApp(url_data.clientId, url_data.appId, data);
    props.history.push(`/clients/${url_data.clientId}/#settings`);
  };

  const closeChangeStatus = () => {
    setInfoAlert(false);
  };

  const onClickStatus = (appName, currentStatus) => {
    const data = {
      appName,
      currentStatus,
      onConfirm: () => {
        props.patchAppStatus(url_data.appId, {
          is_active: !currentStatus,
        });
        closeChangeStatus();
      },
    };
    setInfoData(data);
    setInfoAlert(!infoAlert);
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <ModifiedMetaTags title="Edit application | Mobihunter" />

        {props.permissions["change_clientapplicationmodel"] && infoAlert && (
          <SweetAlert
            showCancel
            confirmBtnText="Change"
            cancelBtnText="Cancel"
            confirmBtnBsStyle="success"
            title="Change application status"
            onCancel={() => closeChangeStatus()}
            onConfirm={infoData.onConfirm}
          >
            {infoData?.currentStatus ? (
              <p>Are you sure want to change application status to inactive?</p>
            ) : (
              <p>Are you sure want to change application status to active?</p>
            )}
          </SweetAlert>
        )}
        <Container fluid>
          <Breadcrumbs
            title="Client"
            breadcrumbItem={"Edit application"}
            link={`/clients/${props.match.params.clientId}/#settings`}
          />
          {props.app !== null && (
            <ApplicationForm
              onSubmitForm={onSubmitForm}
              app_data={props.app_data}
              app={props.app}
              app_id={url_data.appId}
              tracking_platforms={props.tracking_platforms}
              changeStatusApp={onClickStatus}
              type="edit"
              permissions={props.permissions}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

EditApplication.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.node,
      appId: PropTypes.node,
    }).isRequired,
  }).isRequired,
  history: PropTypes.object.isRequired,
  getAppData: PropTypes.func.isRequired,
  setAppDataNull: PropTypes.func.isRequired,
  getApp: PropTypes.func.isRequired,
  patchAppStatus: PropTypes.func.isRequired,
  app_data: PropTypes.any,
  app: PropTypes.any,
  loading: PropTypes.bool,
  getTrackerPlatforms: PropTypes.func.isRequired,
  setApp: PropTypes.func.isRequired,
  tracking_platforms: PropTypes.any,
  patchApp: PropTypes.func.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  app: state.Apps.app,
  app_data: state.Apps.app_data,
  loading: state.Apps.loading,
  tracking_platforms: state.Meta.tracking_platforms,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  patchApp,
  patchAppStatus,
  setAppDataNull,
  getAppData,
  getApp,
  setApp,
  getTrackerPlatforms,
})(withRouter(EditApplication));
